export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-3">
              保持联系
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 mt-2">有问题或建议？随时与我们取得联系</p>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">意见反馈</h3>
                <p className="text-xs text-foreground-500">如需反馈建议或报告问题，欢迎通过站内渠道联系我们</p>
                <a
                  href="#contact"
                  className="inline-block mt-3 text-xs text-primary-600 font-medium hover:text-primary-700 whitespace-nowrap"
                >
                  发送反馈
                  <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>

              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-accent-100 text-accent-600 rounded-xl">
                  <i className="ri-chat-3-line text-lg"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">内容合作</h3>
                <p className="text-xs text-foreground-500">内容提供方或版权方如有合作意向，欢迎与我们洽谈</p>
                <a
                  href="#contact"
                  className="inline-block mt-3 text-xs text-accent-600 font-medium hover:text-accent-700 whitespace-nowrap"
                >
                  了解合作
                  <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>

              <div className="p-5 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-xl">
                  <i className="ri-information-line text-lg"></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">常见问题</h3>
                <p className="text-xs text-foreground-500">查看天天影院常见问题解答，快速了解平台使用方式</p>
                <a
                  href="#faq"
                  className="inline-block mt-3 text-xs text-secondary-600 font-medium hover:text-secondary-700 whitespace-nowrap"
                >
                  查看 FAQ
                  <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}